// React imports
import React from 'react';

// Project imports
import OpportunityOneOffBaseScreen from './OpportunityOneOffBaseScreen';
import OpportunityOneOffBuilder from './OpportunityOneOffBuilder';
import OpportunityPreviewAndSend from './OpportunityPreviewAndSend';

function OpportunityOneOffScreen(props) {
    return (
        <OpportunityOneOffBaseScreen
            type='one-off'
            Builder={OpportunityOneOffBuilder}
            PreviewAndSend={OpportunityPreviewAndSend}
            {...props}
        />
    );
}

export default OpportunityOneOffScreen;